<template>
  <div>
    <v-card-actions class="justify-space-around px-0">
      <v-btn icon text @click="prev">
        <v-icon color="#29284c">mdi-chevron-left</v-icon>
      </v-btn>
      <v-item-group v-model="onboarding" class="text-center" mandatory>
        <v-item
          v-for="n in components.length + 1"
          :key="`btn-${n}`"
          v-slot:default="{ active, toggle }"
        >
          <v-btn icon @click="toggle" :input-value="active">
            <v-icon color="#29284c">mdi-record</v-icon>
          </v-btn>
        </v-item>
      </v-item-group>
      <v-btn icon text @click="next">
        <v-icon color="#29284c">mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
    <v-window v-model="onboarding">
      <v-row align="center" justify="center">
        <v-window-item>
          <app-add @new-exercise="newExercise" />
        </v-window-item>
        <v-window-item v-for="(item, index) in components" :key="'Component ' + index">
          <v-card
            max-width="700"
            width="80vw"
            :flat="!!(grammar_step && grammar_step.uuid)"
            min-height="500"
            class="px-5 py-3 custom-scroll"
            :class="{ 'overflow-y-auto': !(grammar_step && grammar_step.uuid) }"
            max-height="80vh"
          >
            <v-btn
              color="#FF347C"
              @click="onDelete(index)"
              text
              :absolute="!$vuetify.breakpoint.xs"
              right
              class="text-capitalize d-flex ml-auto"
            >
              Delete Exercise
              <v-icon color="#FF347C">mdi-delete</v-icon>
            </v-btn>
            <v-form :ref="'form' + index" @submit.prevent>
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    :rules="[rules.required]"
                    v-model="item.crud.name"
                    label="Title"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :rules="[rules.required]"
                    v-model="item.crud.focus"
                    label="Focus"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    rows="3"
                    :rules="[rules.required]"
                    v-model="item.crud.description"
                    label="Directions"
                  ></v-textarea>
                </v-col>
              </v-row>
              <component
                :is="item.crud.ex_type"
                :question_group="item.crud.question_group"
                :ref="'components' + index"
              ></component>
            </v-form>
            <v-btn
              class="d-flex ml-auto"
              :loading="loading"
              text
              color="pink"
              @click="onSave(index)"
              >Save</v-btn
            >
          </v-card>
        </v-window-item>
      </v-row>
    </v-window>
    <app-selection-dialog v-model="dialog" :items="items" @new-grammar="newGrammar" />
  </div>
</template>
<script>
import Add from "./Add.vue";
import SelectionDialog from "./Selection Dialog.vue";
import rulesMixin from "@/mixins/rulesMixin";
import { postExercise, deleteGrammarExercise } from "@/api/api";

export default {
  mixins: [rulesMixin],
  components: {
    appAdd: Add,
    appSelectionDialog: SelectionDialog,
  },
  props: {
    value: {
      required: false,
      default: false,
      type: Boolean,
    },
    grammar_step: {
      required: false,
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      components: [],
      onboarding: 0,
      dialog: false,
      crud: {},
      items: [
        {
          event: "new-grammar",
          component: "Multiple3",
          text: "Multiple Choice 3",
        },
        {
          event: "new-grammar",
          component: "Transcript",
          text: "Multiple Choice Plus",
        },
        {
          event: "new-grammar",
          component: "SenStruct",
          text: "Multiple Choice",
        },
        {
          event: "new-grammar",
          component: "Fill",
          text: "Rewriting",
        },
        {
          event: "new-grammar",
          component: "Pictures",
          text: "Pictures",
        },
        {
          event: "new-grammar",
          component: "Custom",
          text: "Custom Exercise",
        },
      ],
      loading: false,
    };
  },
  computed: {
    grammar() {
      return this.$store.getters["admin/grammar"];
    },
  },
  methods: {
    async onDelete(index) {
      if (this.components[index].crud.uuid) {
        if (this.grammar_step && this.grammar_step.uuid) {
          await deleteGrammarExercise(this.components[index].crud, "teach");
        } else await deleteGrammarExercise(this.components[index].crud, "grammar");
      }
      this.components.splice(index, 1);
    },
    next() {
      this.onboarding =
        this.onboarding + 1 === this.components.length + 1 ? 0 : this.onboarding + 1;
    },
    prev() {
      this.onboarding = this.onboarding - 1 < 0 ? this.components.length : this.onboarding - 1;
    },
    newExercise() {
      this.dialog = true;
    },
    newGrammar(value) {
      if (!this.$options.components[value]) {
        this.$options.components[value] = () => import(`./${value}.vue`);
      }
      this.components.push({ crud: { ex_type: value, question_group: {} } });
      this.onboarding = this.components.length;
      this.dialog = false;
    },
    async onSave(index) {
      if (!this.$refs["form" + index][0].validate()) return;
      this.loading = true;
      let crud = { ...this.components[index].crud };

      if (this.grammar_step && this.grammar_step.uuid) {
        crud.grammar_step = this.grammar_step.uuid;
      } else crud.grammar = this.grammar.uuid;

      const response = await postExercise(crud);
      this.components[index].crud.uuid = response.data.uuid;

      if (response.data.question_group.uuid) {
        this.components[index].crud.question_group.uuid = response.data.question_group.uuid;
      } else this.components[index].crud.question_group.uuid = response.data.question_group;

      this.components[index].crud.question_group = await this.$refs["components" + index][0].save(
        this.components[index].crud.question_group.uuid,
      );
      this.loading = false;
    },
    create() {
      let iterable = [];
      if (this.grammar_step && this.grammar_step.exercises) {
        iterable = this.grammar_step.exercises;
      } else iterable = this.grammar.exercises;

      iterable.forEach((element) => {
        this.components.push({ crud: element });
        if (!this.$options.components[element.ex_type]) {
          this.$options.components[element.ex_type] = () => import(`./${element.ex_type}.vue`);
        }
      });
    },
  },
  watch: {
    value(val) {
      if (!val) {
        this.components = [];
      } else {
        this.create();
      }
    },
  },
  created() {
    this.create();
  },
};
</script>
